import { createReducer, on } from '@ngrx/store';
import { remove } from 'lodash';

import { User } from '../../pages/users/user';
import { PremiitError } from '../../utils/premiit-error';
import * as userActions from '../actions/users.actions';

export interface UserState {
  data: User[];
  selected: User;
  loading: boolean;
  error: PremiitError;
}

const userInitState: UserState = {
  data: [],
  selected: null,
  loading: false,
  error: null,
};

const _userReducer = createReducer(userInitState,
  on(userActions.getUsersAction, (state) => ({ ...state, loading: true })),
  on(userActions.getUserSucessAction, (state, { users }) => ({
    ...state,
    data: [...users],
    loading: false,
    error: null,
  })),
  on(userActions.getUserErrorAction, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(userActions.selecteUserAction, (state, { user }) => ({
    ...state,
    selected: { ...user }
  })),
  on(userActions.unselectUserAction, (state) => ({
    ...state,
    selected: null
  })),
  on(userActions.createUserAction, (state, { user }) => ({
    ...state,
    loading: true,
  })),
  on(userActions.createUserSucessAction, (state) => ({
    ...state,
    loading: false,
    error: null
  })),
  on(userActions.createUserErrorAction, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(userActions.deleteUserAction, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(userActions.deleteUserSucessAction, (state, { user }) => {
    const users = [...state.data];
    remove(users, (item: User) => (user.id === item.id));
    return {
      ...state,
      loading: false,
      error: null,
      selected: null,
      data: users
    };
  }),
  on(userActions.deleteUserErrorAction, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(userActions.updateUserAction, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(userActions.updateUserSucessAction, (state, { user }) => {
    const users = [...state.data];
    users.forEach((item: User) => {
      if (item.id === user.id) {
        item = user;
      }
    });
    return {
      ...state,
      loading: false,
      error: null,
      data: users,
      selected: null
    };
  }),
  on(userActions.updateUserErrorAction, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
);

export function UserReducer(state, action): any {
  return _userReducer(state, action);
}
